// VaultSafe site configuration.
// EDIT THESE PLACEHOLDERS BEFORE GOING LIVE.
// They flow through every page (header, footer, contact, legal pages, wa.me links).

export const site = {
  brandName: "VaultSafe",
  tagline: "Managed cloud backup for Indian businesses.",
  domain: "vaultsafe.in",
  // Customer login portal (UrBackup server). Opens in a new tab.
  customerPortalUrl: "https://backup.vaultsafe.in",

  // Business details.
  legalEntity: "VaultSafe",
  address: {
    line1: "7, Lok Kedar, JSD Road",
    line2: "Mulund West, Mumbai 400080",
    country: "India",
  },
  phoneDisplay: "+91 97694 44455",
  phoneTel: "+919769444455",
  whatsappNumber: "919769444455",
  email: "hello@vaultsafe.in",
  supportEmail: "support@vaultsafe.in",
  gstin: "XXXXXXXXXXXXXXX",
  businessHours: "Mon–Sat, 10:00 AM to 7:00 PM IST",
  grievanceOfficer: {
    name: "[Grievance Officer Name]",
    email: "grievance@vaultsafe.in",
    responseHours: "72 hours",
  },

  // Default WhatsApp opener text
  waDefaultMessage: "Hi, I want to know more about VaultSafe.",
};

export const waLink = (text) =>
  `https://wa.me/${site.whatsappNumber}?text=${encodeURIComponent(text || site.waDefaultMessage)}`;

// Pricing plans (per PC, per month, billed annually)
export const plans = [
  {
    id: "lite",
    name: "Lite",
    price: 199,
    tagline: "For a single computer",
    storage: "25 GB",
    history: "15 days",
    support: "Email",
    highlight: false,
  },
  {
    id: "basic",
    name: "Basic",
    price: 299,
    tagline: "For a busy laptop",
    storage: "50 GB",
    history: "15 days",
    support: "Email",
    highlight: false,
  },
  {
    id: "standard",
    name: "Standard",
    price: 499,
    tagline: "For most small offices",
    storage: "100 GB",
    history: "15 days",
    support: "Email + Phone",
    highlight: false,
  },
  {
    id: "pro",
    name: "Pro",
    price: 1249,
    tagline: "For heavy files & records",
    storage: "250 GB",
    history: "15 days",
    support: "Priority",
    highlight: false,
  },
  {
    id: "business",
    name: "Business",
    price: 2499,
    tagline: "For serious workloads",
    storage: "500 GB",
    history: "15 days",
    support: "Priority",
    highlight: true,
    badge: "Best Protection",
  },
];

export const faqs = [
  {
    q: "Will it slow down my computer?",
    a: "No. It runs quietly in the background, usually at night, and uses very little of your machine.",
  },
  {
    q: "Is my data safe and private?",
    a: "Your files are encrypted in transit and at rest. We don't look at your data, and we don't share it with anyone.",
  },
  {
    q: "What if my internet is slow?",
    a: "The first backup takes the longest — sometimes a few days. After that, only changed files are sent, so it's quick.",
  },
  {
    q: "What if I delete a file by mistake?",
    a: "Message us. We'll restore it from your file history.",
  },
  {
    q: "What happens if my laptop is stolen?",
    a: "Your data is in the cloud, untouched. We restore it onto your new machine.",
  },
  {
    q: "Does this protect me from ransomware?",
    a: "Ransomware locks the files on your computer. Your backup copy sits somewhere else, so we restore from it. That's exactly what a backup is for.",
  },
  {
    q: "Can you restore my whole computer, including Windows?",
    a: "No — VaultSafe backs up files and folders, not the operating system. We restore your data onto a working computer.",
  },
  {
    q: "How many computers can I cover?",
    a: "As many as you like. Pricing is per computer.",
  },
  {
    q: "Do I need to do anything daily?",
    a: "No. That's the whole point.",
  },
  {
    q: "Is there a contract?",
    a: "Plans are annual. If you're not happy, see our Refund Policy.",
  },
  {
    q: "Do you support Mac / Linux?",
    a: "Windows today. Talk to us about other systems.",
  },
  {
    q: "Who runs VaultSafe?",
    a: "VaultSafe is run by an IT services team based in Mumbai. We've been supporting local businesses for years — VaultSafe is the backup service we built because too many of our clients lost data.",
  },
];
